
import { cScene } from "../../cScene";
import { cSprite } from "../cSprite";
import { Module } from "./Module";

interface draggingOptions {
  dist: number
  snap: boolean
  return: boolean
  
  //compare dist(point) or area(area inside)        
  compare: 'dist' | 'area'

  //single or multiple
  type: 'single' | 'multiple'
}


export class Drag extends Module{

  private targets:any[] = []
  private curTarget:any
  private dragOptions!:draggingOptions
  private dragDefaultOptions!:draggingOptions

  private _enabled!:boolean
  private snapTween:any;


  init() {     
    if (this.data.dragtarget && !(this.ref.scene as cScene).debugMode){
            
      this._enabled = true

      //this.playPreset(this.data.animpreset,this.data.animoptions  )
      var cS = this.ref.scene as cScene
      this.dragDefaultOptions = {
        dist:30,
        snap:true,
        return:false,
        compare:'dist',      
        type:'single'
      }

      try {
        let paramOptions = JSON.parse(this.data.dragoptions as string);
        this.dragOptions = {...this.dragDefaultOptions,...paramOptions}
      }catch(e){
        console.warn('Drag Options Error',this.data.dragoptions)
        this.dragOptions = {...this.dragDefaultOptions}
      }

      setTimeout(()=>{
        var tg = cS.getByName(this.data.dragtarget as string);
        if (tg){
          if (tg instanceof Phaser.GameObjects.Container){
            this.targets = (tg as Phaser.GameObjects.Container).getAll()
          }else{
            this.targets = [tg]
          }
        }else{
          console.warn(`target [${this.data.dragtarget}] not found`)
        }
      },1)

      if (this.ref instanceof Phaser.GameObjects.Container){
        var s = new Phaser.Geom.Rectangle(0, 0, 0, 0)
        this.ref.setInteractive(s,(a,x,y,e)=>{
          var r = this.ref.getBounds()
          return (x > 0 && x < r.width && y > 0 && y < r.height)
        });
        //this.ref.setSize(400,400)
      }else{
        this.ref.setInteractive({useHandCursor:true, draggable: true });
      }

      cS.input.setDraggable( this.ref )
      cS.input.on('dragstart',(p:any,gameObj:any)=>{
        if (gameObj !== this.ref) return        
        if (!this._enabled) return
        
        cS.triggerSceneEvent('start_drag',{'drag':this.ref.name})

        if (this.curTarget) {
          if (this.dragOptions.type === 'single'){
            if (this.curTarget.dragitem && this.curTarget.dragitem[0] === this.ref){
              this.curTarget.dragitem = []
            }
          }else if (this.dragOptions.type === 'multiple'){
            let idx = this.curTarget.dragitem.indexOf(this.ref)
            this.curTarget.dragitem.splice(idx,1)
          }
          this.curTarget = null
        }
      })
      
      cS.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
        if (gameObj !== this.ref) return
        if (!this._enabled) return
        gameObj.x = Math.round(x);
        gameObj.y = Math.round(y);
      });  



      cS.input.on('dragend',(p:any, gameObj:any)=>{
        if (gameObj !== this.ref) return
        if (!this._enabled) return

        console.log('ENDDRAG',this.dragOptions)

        let returnObject:boolean = false
        let ref:cSprite = gameObj as cSprite;
        //let cidx:number = 0;
        let forceReturn: boolean = false;
        var dist = this.targets.filter( (t:cSprite,i:number)=>{
          //compare by distance
          if (this.dragOptions.compare === 'dist'){
            var d = t.modules.layout.getDistance(ref)
            if (d < this.dragOptions.dist){
             // cidx = i;
            }
            
            return d < this.dragOptions.dist  
          }
          //compare by area
          if (this.dragOptions.compare === 'area'){
            var b = t.getBounds();
            console.log('AREA',b,this.ref.x,this.ref.y,'===',Phaser.Geom.Rectangle.Contains(b,this.ref.x,this.ref.y));
            return Phaser.Geom.Rectangle.Contains(b,this.ref.x,this.ref.y)            
          }
          return 0
        })

        console.log('DIST a',dist);

        if (dist.length > 0){

          if (!Array.isArray(dist[0].dragitem)){            
            console.log('RESET');
            dist[0].dragitem = []
          }


          console.log('TYPE',this.dragOptions.type);


          // eslint-disable-next-line
          let idx;
          if (this.dragOptions.type === 'single'){
            if (dist[0].dragitem.length > 0) {
              returnObject = true
              forceReturn = true
            }else{
              dist[0].dragitem = [this.ref]
            }
          }else if (this.dragOptions.type === 'multiple'){
            if (dist[0].dragitem.indexOf(this.ref) !== -1){
              returnObject = true
            }else{
              dist[0].dragitem.push(this.ref)
            }
          }

          if (!forceReturn){
            this.curTarget = dist[0]
          }

          if (this.dragOptions.snap && !returnObject){
            this.snapTween = this.ref.scene.tweens.add({
              targets:[this.ref],
              x: this.curTarget.x,
              y: this.curTarget.y,
              ease: Phaser.Math.Easing.Elastic.Out,
              duration: 800
            });            
          }
          if (this.curTarget){
            cS.triggerSceneEvent('drop',{'drag':this.ref.name,'tg': this.curTarget.name})
          }else{
            cS.triggerSceneEvent('drop',{'drag':this.ref.name,'tg': null,'ofs':this.ref.x+'x'+this.ref.y})  
          }
        }else{
          console.log('OUTSIDE', this.dragOptions)
          cS.triggerSceneEvent('drop',{'drag':this.ref.name,'tg': null,'ofs':this.ref.x+'x'+this.ref.y})
          returnObject = true
        }


        if (returnObject && (this.dragOptions.return || forceReturn)){
          console.log('return');
          this.returnToOrigin()
        }
        
      })    


    }
  }

  public returnToOrigin(){
    var ofs = (this.ref as any).modules.layout.getOfs()

    if (this.snapTween){
      this.snapTween.stop();
    }


    this.ref.scene.tweens.add({
      targets:[this.ref],
      x: ofs.x,
      y: ofs.y,
      ease: Phaser.Math.Easing.Back.Out,
      duration: 400,
      onComplete:()=>{
        console.log('returned');
        this.ref.x = ofs.x;
        this.ref.y = ofs.y;
      }
    });            

  }


  public set enabled(v:boolean){
    console.log('SET ENABLED',v)
    this._enabled = v
  }

}
